// extracted by mini-css-extract-plugin
module.exports = {"selected-filters":"SelectedFilters_selected-filters__1ylFc","remove-all-button":"SelectedFilters_remove-all-button__r-z5U"};